import { Directive } from '@angular/core';
import { UntypedFormControl, NG_VALIDATORS, Validator } from '@angular/forms';
import { ValidationErrors } from '@angular/forms';

export const EMAIL_REGEX = new RegExp('^[a-zA-Z0-9.!#$%&\'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$');

@Directive({
  selector: '[townipEmailPatternValidator]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: ValidateEmailPatternDirective,
      multi: true
    }
  ]
})
export class ValidateEmailPatternDirective implements Validator {
  public static validateEmailPattern(control: UntypedFormControl): ValidationErrors | null {
    // self value (e.g. retype password)
    const value = control.value;

    // value not equal
    if (!EMAIL_REGEX.test(value)) {
      return { validateEqual: false };
    }
    return null;
  }

  constructor() {
  }

  public validate(c: UntypedFormControl): { [key: string]: ValidationErrors | null } {
    return ValidateEmailPatternDirective.validateEmailPattern(c);
  }
}
